export const isResponse = maybe => typeof maybe === 'object' && typeof maybe.status === 'number';